(function () {
  'use strict';

  var portrait = null;
  var voice = null;
  var customVoiceURL = '';
  var backends = [];
  var defaultCharacters = [];
  var backend = null;
  var voiceFilter = '';
  var styleFilter = '';
  var portraitTimer = 0;
  var sourcePortraitTimer = 0;
  var voiceTimer = 0;
  var portraitPage = { offset: 0, total: 0, loading: false, done: false };
  var sourcePage = { offset: 0, total: 0, loading: false, done: false };
  var recorder = null;
  var recording = false;
  var recordingChunks = [];
  var pollTimer = 0;
  var avatarBlinkTimer = 0;
  var avatarFrame = 0;
  var avatarBlinking = false;
  var avatarMouthShape = 'closed';
  var avatarPackCredits = 32;
  var avatarVideoCredits = 364;
  var avatarTalking = false;
  var avatarAudioReactive = false;
  var avatarStartedAt = 0;
  var avatarVoiceLevel = 0;
  var avatarAudioContext = null;
  var avatarAudioSource = null;
  var avatarAnalyser = null;
  var avatarAudioBuffer = null;
  var avatarRecordDestination = null;
  var avatarWebcamStream = null;
  var avatarMicSource = null;
  var avatarMicAnalyser = null;
  var avatarMicBuffer = null;
  var avatarFaceLandmarker = null;
  var avatarWebcamFrame = 0;
  var avatarWebcamRunning = false;
  var avatarWebcamReady = false;
  var avatarWebcamCalibrating = false;
  var avatarWebcamCalibration = null;
  var avatarWebcamLastTime = -1;
  var avatarWebcamLastSeen = 0;
  var avatarPose = { x: 0, y: 0, roll: 0 };
  var avatarTrackedMouthLevel = 0;
  var avatarTrackedBlink = false;
  var performanceRecorder = null;
  var performanceChunks = [];
  var performanceFrame = 0;
  var performanceStream = null;
  var performanceURL = '';
  var performanceImages = {};
  var avatarFrameImages = {};
  var avatarExternalLevel = 0;
  var avatarExternalUntil = 0;
  var avatarFixed = false;
  var avatarTestMode = new URLSearchParams(window.location.search).get('test') === 'true';
  var avatarAssetKeys = [
    'eyes_open_mouth_closed',
    'eyes_open_mouth_half',
    'eyes_open_mouth_open',
    'eyes_closed_mouth_closed',
    'eyes_closed_mouth_half',
    'eyes_closed_mouth_open',
  ];
  var emotionPacks = {
	all: ['happy', 'sad', 'worried', 'indifferent', 'angry', 'flirty', 'in_love', 'surprised', 'amused', 'embarrassed', 'determined', 'skeptical'],
    core: ['happy', 'sad', 'worried', 'angry', 'flirty', 'in_love'],
    social: ['indifferent', 'surprised', 'amused', 'embarrassed', 'determined', 'skeptical'],
  };
  var avatarTrackingConfig = {
    visionModuleUrl: 'https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.35/vision_bundle.mjs',
    wasmRoot: 'https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.35/wasm',
    modelAssetPath: 'https://storage.googleapis.com/mediapipe-models/face_landmarker/face_landmarker/float16/latest/face_landmarker.task',
    calibrationFrames: 24,
    yawGain: 1.45,
    pitchGain: 6,
  };

  function byID(id) {
    return document.getElementById(id);
  }

  function setStatus(message, isError) {
    var node = byID('tc-status');
    if (!node) return;
    node.textContent = message;
    node.classList.toggle('tc-err', !!isError);
  }

  function credentials() {
    var creds = (typeof window.getAuthCredentials === 'function' ? window.getAuthCredentials() : {}) || {};
    return creds.secret || (window.userData && window.userData.secret) || null;
  }

  function requireLogin() {
    if (window.NetwrckTools && typeof window.NetwrckTools.requireLogin === 'function') {
      window.NetwrckTools.requireLogin();
      return;
    }
    window.location.href = '/login?next=' + encodeURIComponent(location.pathname + location.search);
  }

  function handlePaymentRequired(response, data) {
    if (!response || response.status !== 402) return false;
    var message = (data && (data.error || data.message)) || 'Insufficient credits.';
    var required = Number(data && (data.required || data.credits_required || data.credits));
    if (!required) {
      var match = String(message).match(/Required:\s*(\d+)/i);
      if (match) required = Number(match[1]);
    }
    if (typeof window.handleInsufficientCredits === 'function') {
      window.handleInsufficientCredits({ required: required, message: message });
      return true;
    }
    if (window.NetwrckTools && typeof window.NetwrckTools.handlePaymentRequired === 'function') {
      window.NetwrckTools.handlePaymentRequired(required, message);
      return true;
    }
    if (typeof window.showTopupDialog === 'function') {
      window.showTopupDialog();
      return true;
    }
    if (window.EmbeddedCheckout && typeof window.EmbeddedCheckout.open === 'function') {
      window.EmbeddedCheckout.open({ amount: 20, type: 'credits' });
      return true;
    }
    return false;
  }

  function estimateSeconds() {
    var length = byID('tc-text').value.trim().length;
    if (!length) return 0;
    return Math.max(2, length / 14);
  }

  function estimateCredits() {
    var seconds = estimateSeconds();
    if (!backend) return 0;
    var clamped = Math.min(Math.max(seconds, backend.min_seconds || 2), backend.max_seconds || 120);
    var credits = Math.ceil((backend.retail_usd_per_second || backend.usd_per_second * 1.2) * clamped * 100);
    var length = byID('tc-text').value.trim().length;
    if (length) credits += Math.max(1, Math.ceil((length / 1000) * 0.05 * 1.2 * 100));
    if (byID('tc-portrait-edit').value.trim() && backend.input === 'portrait') credits += 4;
    return Math.max(1, credits);
  }

  function refreshEstimate() {
    var length = byID('tc-text').value.length;
    var seconds = estimateSeconds();
    byID('tc-char-count').textContent = length + (length === 1 ? ' character' : ' characters');
    byID('tc-duration').textContent = 'about ' + Math.round(seconds) + 's of speech';
    var credits = estimateCredits();
    byID('tc-generate').textContent = credits
      ? 'Generate talking video · ' + credits + (credits === 1 ? ' credit' : ' credits')
      : 'Generate talking video';
  }

  function selectPortrait(next) {
    portrait = next;
    performanceImages = {};
    avatarFrameImages = {};
    var transitionStages = ['tc-avatar-stage', 'tc-narrator-stage'].map(byID).filter(Boolean);
    transitionStages.forEach(function (stage) { stage.classList.add('tc-avatar-changing'); });
    var reveal = function () {
      if (portrait !== next) return;
      transitionStages.forEach(function (stage) { stage.classList.remove('tc-avatar-changing'); });
    };
    document.querySelectorAll('.tc-avatar-motion').forEach(function (node) {
      node.style.removeProperty('transition');
    });
    byID('tc-selected-portrait-img').src = next.image_url;
    byID('tc-selected-portrait-name').textContent = next.name || 'Custom portrait';
    byID('tc-selected-portrait-meta').textContent = [next.style, next.archetype].filter(Boolean).join(' · ') || next.source || 'Ready to animate';
    document.querySelectorAll('.tc-card').forEach(function (card) {
      card.classList.toggle('tc-on', card.dataset.variantKey === avatarVariantKey(next));
    });
    avatarBlinking = false;
    avatarMouthShape = 'closed';
    renderAvatarExpression();
    preloadAvatarFrames();
    var probe = new Image();
    probe.onload = reveal;
    probe.onerror = reveal;
    probe.src = avatarImageFor('eyes_open_mouth_closed');
    if (probe.complete) window.requestAnimationFrame(reveal);
    window.setTimeout(reveal, 1800);
    scheduleAvatarBlink();
    avatarFixed = false;
    ensureAvatarLoop();
    refreshAvatarUI();
    refreshEstimate();
  }

  function hasVideoAvatar(item) {
    return !!(item && item.assets && typeof item.assets.video_loop === 'string' && item.assets.video_loop);
  }

  function hasAnimatedAvatar(item) {
    return !!(item && item.assets && avatarAssetKeys.every(function (key) {
      return typeof item.assets[key] === 'string' && item.assets[key];
    }));
  }

  function avatarVariantKey(item) {
    return (item && item.slug || '') + ':' + (item && item.avatar_variant || (hasVideoAvatar(item) ? 'video' : 'animated'));
  }

  function avatarResultVariants(item) {
    var variants = [];
    if (hasAnimatedAvatar(item)) {
      var animated = Object.assign({}, item, { avatar_variant: 'animated', assets: Object.assign({}, item.assets) });
      delete animated.assets.video_loop;
      delete animated.assets.video_opaque;
      variants.push(animated);
    }
    if (hasVideoAvatar(item)) variants.push(Object.assign({}, item, { avatar_variant: 'video' }));
    return variants;
  }

  function avatarImageFor(expression) {
    if (!portrait) return '';
    return (portrait.assets && portrait.assets[expression]) || portrait.image_url || '';
  }

  var avatarFrameRetryDelays = [500, 2000, 6000];

  function avatarFrameLoaded(url) {
    var entry = avatarFrameImages[url];
    return !!(entry && entry.loaded && entry.image.complete && entry.image.naturalWidth > 0);
  }

  function preloadAvatarFrames() {
    if (!portrait) return;
    var urls = [portrait.image_url];
    if (portrait.assets) avatarAssetKeys.forEach(function (key) { urls.push(portrait.assets[key]); });
    urls.filter(Boolean).forEach(function (url) {
      if (avatarFrameImages[url]) return;
      var entry = { image: new Image(), loaded: false, failed: false, attempts: 0, timer: 0 };
      avatarFrameImages[url] = entry;
      loadAvatarFrame(url, entry);
    });
  }

  function loadAvatarFrame(url, entry) {
    entry.attempts += 1;
    var image = entry.image;
    var markLoaded = function () {
      if (entry.loaded) return;
      entry.loaded = true;
      entry.failed = false;
      var current = avatarImageFor('eyes_' + (avatarBlinking ? 'closed' : 'open') + '_mouth_' + avatarMouthShape);
      if (current === url) renderAvatarExpression();
    };
    image.onload = function () {
      if (image.complete && image.naturalWidth > 0) {
        markLoaded();
        return;
      }
      entry.loaded = false;
      scheduleAvatarFrameRetry(url, entry);
    };
    image.onerror = function () {
      if (entry.loaded) return;
      entry.loaded = false;
      scheduleAvatarFrameRetry(url, entry);
    };
    image.src = url;
    if (image.decode) image.decode().then(markLoaded, function () {});
  }

  function scheduleAvatarFrameRetry(url, entry) {
    if (avatarFrameImages[url] !== entry) return;
    if (entry.attempts > 3) {
      entry.failed = true;
      return;
    }
    window.clearTimeout(entry.timer);
    entry.timer = window.setTimeout(function () {
      if (avatarFrameImages[url] !== entry || entry.loaded) return;
      loadAvatarFrame(url, entry);
    }, avatarFrameRetryDelays[Math.min(entry.attempts - 1, avatarFrameRetryDelays.length - 1)]);
  }

  function swapAvatarFrame(image, url) {
    if (!image || !url || image.dataset.frameUrl === url) return;
    if (!avatarFrameLoaded(url)) {
      if (!avatarFrameImages[url]) preloadAvatarFrames();
      var fallback = avatarImageFor('eyes_open_mouth_closed') || (portrait && portrait.image_url) || '';
      if (fallback && fallback !== url && image.dataset.frameUrl !== fallback && avatarFrameLoaded(fallback)) {
        swapAvatarFrame(image, fallback);
      }
      return;
    }
    var previous = image.dataset.frameUrl;
    image.dataset.frameUrl = url;
    if (!previous || !image.parentElement || (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) {
      image.src = url;
      return;
    }
    var blend = image.parentElement.querySelector('.tc-avatar-blend');
    if (!blend) {
      blend = document.createElement('img');
      blend.className = 'tc-avatar-blend';
      blend.alt = '';
      blend.setAttribute('aria-hidden', 'true');
      image.parentElement.appendChild(blend);
    }
    if (blend.getAnimations) blend.getAnimations().forEach(function (animation) { animation.cancel(); });
    blend.src = previous;
    blend.style.opacity = '1';
    image.src = url;
    if (typeof blend.animate !== 'function') {
      blend.style.opacity = '0';
      return;
    }
    var animation = blend.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 78, easing: 'linear', fill: 'forwards' });
    animation.onfinish = function () { blend.style.opacity = '0'; };
  }

  function renderAvatarExpression() {
    var expression = 'eyes_' + (avatarBlinking ? 'closed' : 'open') + '_mouth_' + avatarMouthShape;
    if (hasVideoAvatar(portrait)) {
      ['tc-avatar-stage', 'tc-narrator-stage'].forEach(function (id) {
        var stage = byID(id);
        if (stage) stage.dataset.avatarExpression = expression;
      });
      ['tc-avatar-stage-img', 'tc-narrator-img'].forEach(function (id) {
        var image = byID(id);
        if (image) image.style.opacity = '0';
      });
      drawAvatarVideoStages();
      return;
    }
    ['tc-avatar-stage', 'tc-narrator-stage'].forEach(function (id) {
      var stage = byID(id);
      if (!stage) return;
      var canvas = stage.querySelector('.tc-video-avatar');
      if (canvas) canvas.style.display = 'none';
    });
    ['tc-avatar-stage-img', 'tc-narrator-img'].forEach(function (id) {
      var image = byID(id);
      if (image) image.style.opacity = '';
    });
    var url = avatarImageFor(expression);
    ['tc-avatar-stage-img', 'tc-narrator-img'].forEach(function (id) {
      var image = byID(id);
      if (!image || !url) return;
      swapAvatarFrame(image, url);
      image.dataset.expression = expression;
    });
    ['tc-avatar-stage', 'tc-narrator-stage'].forEach(function (id) {
      var stage = byID(id);
      if (stage) stage.dataset.avatarExpression = expression;
    });
  }

  function ensureAvatarVideoStage(stage) {
    if (!stage) return null;
    var canvas = stage.querySelector('.tc-video-avatar');
    if (canvas) return canvas;
    canvas = document.createElement('canvas');
    canvas.className = 'tc-video-avatar';
    canvas.width = 720;
    canvas.height = 720;
    canvas.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;object-fit:contain;object-position:center bottom;pointer-events:none;';
    stage.style.position = stage.style.position || 'relative';
    stage.appendChild(canvas);
    var video = document.createElement('video');
    video.muted = true;
    video.loop = true;
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.hidden = true;
    stage.appendChild(video);
    canvas._video = video;
    return canvas;
  }

  function drawAvatarVideoStages() {
    if (!hasVideoAvatar(portrait)) return;
    var assets = portrait.assets;
    ['tc-avatar-stage', 'tc-narrator-stage'].forEach(function (id) {
      var stage = byID(id);
      var canvas = ensureAvatarVideoStage(stage);
      if (!canvas) return;
      canvas.style.display = 'block';
      var video = canvas._video;
      if (video.src !== assets.video_loop) {
        video.src = assets.video_loop;
        video.play().catch(function () {});
      }
      var ctx = canvas.getContext('2d', { alpha: true });
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      if (video.readyState >= 2) ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
    });
  }

  function setAvatarBuildStatus(message, isError) {
    var nodes = [byID('tc-generate-status'), byID('tc-narrator-status')];
    nodes.forEach(function (node) {
      if (!node) return;
      node.textContent = message;
      node.classList.toggle('tc-err', !!isError);
    });
  }

  function ensureVideoAvatarButton() {
    var button = byID('tc-video-avatar');
    if (button) return button;
    var build = byID('tc-build-avatar');
    if (!build || !build.parentNode) return null;
    button = document.createElement('button');
    button.id = 'tc-video-avatar';
    button.type = 'button';
    button.className = build.className;
    button.textContent = 'Make idle + talking video · ' + avatarVideoCredits + ' credits';
    build.parentNode.insertBefore(button, build.nextSibling);
    button.addEventListener('click', convertVideoAvatar);
    return button;
  }

  function refreshAvatarUI() {
    var ready = hasAnimatedAvatar(portrait);
    var videoReady = hasVideoAvatar(portrait);
    var stillReady = !!(portrait && portrait.assets && avatarAssetKeys.every(function (key) {
      return typeof portrait.assets[key] === 'string' && portrait.assets[key];
    }));
    var build = byID('tc-build-avatar');
    var narratorBuild = byID('tc-narrator-build');
    var videoBtn = ensureVideoAvatarButton();
    if (build) build.hidden = !portrait || stillReady;
    if (narratorBuild) {
      narratorBuild.hidden = !portrait || stillReady;
      narratorBuild.disabled = false;
      narratorBuild.textContent = 'Create transparent animated pack · up to ' + avatarPackCredits + ' credits';
    }
    if (build) build.disabled = false;
    if (videoBtn) {
      videoBtn.hidden = !portrait || !stillReady || videoReady;
      videoBtn.disabled = false;
      videoBtn.textContent = 'Make idle + talking video · ' + avatarVideoCredits + ' credits';
    }
    if (byID('tc-narrator-character')) {
      byID('tc-narrator-character').textContent = portrait ? portrait.name || 'Custom portrait' : 'Choose a character';
      byID('tc-narrator-state').textContent = videoReady
        ? 'Video avatar ready. Original looping video plays during chat audio.'
        : ready
        ? 'Transparent pack ready. Convert to a 15s still-camera video avatar, or use the six PNG states in chat.'
        : 'Portrait preview. Idle movement is active; create a transparent six-state pack for blink and mouth animation.';
    }
  }

  function scheduleAvatarBlink() {
    window.clearTimeout(avatarBlinkTimer);
    if (!portrait) return;
    avatarBlinkTimer = window.setTimeout(function () {
      avatarBlinking = true;
      renderAvatarExpression();
      var stage = byID('tc-avatar-stage');
      if (stage) stage.dataset.blink = 'true';
      window.setTimeout(function () {
        if (stage) delete stage.dataset.blink;
        avatarBlinking = false;
        renderAvatarExpression();
        scheduleAvatarBlink();
      }, 170);
    }, 2600 + Math.random() * 3800);
  }

  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }

  function setAvatarMotion(level, timestamp) {
    var reduced = !avatarTestMode && window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var idle = reduced ? 0 : Math.sin(timestamp / 860);
    var speech = reduced ? 0 : Math.sin(timestamp / 74) * level;
    var poseX = reduced ? 0 : avatarPose.x;
    var poseY = reduced ? 0 : avatarPose.y;
    var poseRoll = reduced ? 0 : avatarPose.roll;
    var x = reduced ? 0 : idle * 1.4 + speech * 2.2 + poseX * 12;
    var y = reduced ? 0 : -2 - idle * 2.8 - Math.abs(speech) * 7.5 + poseY * 9;
    var tilt = reduced ? 0 : idle * 0.65 + speech * 1.15 + poseX * 3.4 + poseRoll * 0.7;
    var scale = reduced ? 1 : 1.008 + level * 0.026 + Math.abs(speech) * 0.012 + Math.abs(poseX) * 0.012;
    document.querySelectorAll('.tc-avatar-motion').forEach(function (node) {
      node.style.setProperty('--tc-x', x.toFixed(2) + 'px');
      node.style.setProperty('--tc-y', y.toFixed(2) + 'px');
      node.style.setProperty('--tc-tilt', tilt.toFixed(2) + 'deg');
      node.style.setProperty('--tc-scale', scale.toFixed(4));
      node.dataset.level = level.toFixed(3);
      node.dataset.pose = [poseX.toFixed(3), poseY.toFixed(3), poseRoll.toFixed(3)].join(' ');
    });
    ['tc-avatar-stage', 'tc-narrator-stage'].forEach(function (id) {
      var stage = byID(id);
      if (stage) stage.dataset.speaking = level > 0.035 ? 'true' : 'false';
    });
  }

  function ensureAvatarAudioContext() {
    var AudioContext = window.AudioContext || window.webkitAudioContext;
    if (!AudioContext) return null;
    avatarAudioContext = avatarAudioContext || new AudioContext();
    if (!avatarRecordDestination) avatarRecordDestination = avatarAudioContext.createMediaStreamDestination();
    avatarAudioContext.resume().catch(function () {});
    return avatarAudioContext;
  }

  function connectAvatarAudio() {
    var player = byID('tc-voice-preview');
    if (!player || avatarAnalyser) return;
    try {
      if (!ensureAvatarAudioContext()) return;
      avatarAudioSource = avatarAudioSource || avatarAudioContext.createMediaElementSource(player);
      avatarAnalyser = avatarAudioContext.createAnalyser();
      avatarAnalyser.fftSize = 512;
      avatarAnalyser.smoothingTimeConstant = 0.24;
      avatarAudioSource.connect(avatarAnalyser);
      avatarAnalyser.connect(avatarAudioContext.destination);
      avatarAnalyser.connect(avatarRecordDestination);
      avatarAudioBuffer = new Uint8Array(avatarAnalyser.fftSize);
    } catch (error) {
      avatarAnalyser = null;
    }
  }

  function analyserLevel(analyser, buffer) {
    if (!analyser || !buffer) return 0;
    analyser.getByteTimeDomainData(buffer);
    var sum = 0;
    for (var i = 0; i < buffer.length; i += 1) {
      var sample = (buffer[i] - 128) / 128;
      sum += sample * sample;
    }
    return clamp(Math.sqrt(sum / buffer.length) * 7.5, 0, 1);
  }

  function measuredAvatarLevel(timestamp) {
    if (avatarExternalUntil > timestamp) return avatarExternalLevel;
    if (avatarMicAnalyser && avatarMicBuffer) return analyserLevel(avatarMicAnalyser, avatarMicBuffer);
    if (!avatarAudioReactive) {
      var seconds = (timestamp - avatarStartedAt) / 1000;
      return Math.max(0, Math.sin(seconds * 17)) * (0.38 + Math.max(0, Math.sin(seconds * 2.3)) * 0.62);
    }
    return analyserLevel(avatarAnalyser, avatarAudioBuffer);
  }

  function avatarTick(timestamp) {
    avatarFrame = 0;
    if (!portrait || avatarFixed) return;
    var raw = avatarTalking ? measuredAvatarLevel(timestamp) : 0;
    avatarVoiceLevel += (raw - avatarVoiceLevel) * (raw > avatarVoiceLevel ? 0.48 : 0.18);
    var mouthLevel = Math.max(avatarVoiceLevel, avatarWebcamRunning ? avatarTrackedMouthLevel : 0);
    var nextMouth = mouthLevel >= 0.62 ? 'open' : mouthLevel >= 0.18 ? 'half' : 'closed';
    var nextBlink = avatarWebcamRunning ? avatarTrackedBlink : avatarBlinking;
    if (nextMouth !== avatarMouthShape || nextBlink !== avatarBlinking) {
      avatarMouthShape = nextMouth;
      avatarBlinking = nextBlink;
      renderAvatarExpression();
    }
    setAvatarMotion(avatarVoiceLevel, timestamp);
    avatarFrame = window.requestAnimationFrame(avatarTick);
  }

  function ensureAvatarLoop() {
    if (!avatarFrame && portrait && !avatarFixed) avatarFrame = window.requestAnimationFrame(avatarTick);
  }

  function startAvatarTalk(audioReactive) {
    if (!portrait) return;
    document.querySelectorAll('.tc-avatar-motion').forEach(function (node) {
      node.style.removeProperty('transition');
    });
    if (audioReactive) connectAvatarAudio();
    avatarFixed = false;
    avatarAudioReactive = !!audioReactive;
    avatarTalking = true;
    avatarStartedAt = performance.now();
    ensureAvatarLoop();
    if (byID('tc-narrator-demo')) byID('tc-narrator-demo').textContent = 'Stop narration preview';
  }

  function stopAvatarTalk() {
    avatarTalking = false;
    avatarVoiceLevel = 0;
    avatarMouthShape = 'closed';
    renderAvatarExpression();
    setAvatarMotion(0, performance.now());
    ensureAvatarLoop();
    if (byID('tc-narrator-demo')) byID('tc-narrator-demo').textContent = 'Preview narration';
  }

  function setPerformanceStatus(message, isError) {
    var node = byID('tc-performance-status');
    if (!node) return;
    node.textContent = message;
    node.classList.toggle('tc-err', !!isError);
  }

  function refreshPerformanceUI() {
    var active = avatarWebcamRunning;
    var recordingNow = !!(performanceRecorder && performanceRecorder.state === 'recording');
    byID('tc-performance-start').disabled = active;
    byID('tc-performance-start').textContent = active ? 'Webcam active' : 'Start webcam + mic';
    byID('tc-performance-calibrate').disabled = !active || !avatarWebcamReady;
    byID('tc-performance-record').disabled = !active;
    byID('tc-performance-record').textContent = recordingNow ? 'Stop & export' : 'Record performance';
    byID('tc-performance-record').classList.toggle('tc-recording', recordingNow);
    byID('tc-performance-stop').disabled = !active;
    byID('tc-narrator-demo').disabled = active;
    byID('tc-narrator-stage').dataset.webcam = active ? 'true' : 'false';
  }

  function resetWebcamCalibration() {
    avatarWebcamCalibrating = true;
    avatarWebcamCalibration = { frames: 0, x: 0, y: 0, roll: 0, baseX: 0, baseY: 0, baseRoll: 0 };
    avatarPose = { x: 0, y: 0, roll: 0 };
    setPerformanceStatus('Face tracking: look straight ahead for calibration.', false);
  }

  function facePoseFromLandmarks(landmarks) {
    var nose = landmarks[1];
    var leftEye = landmarks[33];
    var rightEye = landmarks[263];
    var chin = landmarks[152];
    if (!nose || !leftEye || !rightEye || !chin) return null;
    var eyeMidX = (leftEye.x + rightEye.x) * 0.5;
    var eyeMidY = (leftEye.y + rightEye.y) * 0.5;
    var halfWidth = Math.abs(rightEye.x - leftEye.x) * 0.5;
    var eyeToChin = Math.abs(chin.y - eyeMidY);
    return {
      x: halfWidth > 0.01 ? (nose.x - eyeMidX) / halfWidth : 0,
      y: eyeToChin > 0.01 ? (eyeMidY - nose.y) / eyeToChin : 0,
      roll: Math.atan2(rightEye.y - leftEye.y, rightEye.x - leftEye.x) * 180 / Math.PI,
    };
  }

  async function createAvatarFaceLandmarker(delegate) {
    var vision = await import(avatarTrackingConfig.visionModuleUrl);
    var fileset = await vision.FilesetResolver.forVisionTasks(avatarTrackingConfig.wasmRoot);
    return vision.FaceLandmarker.createFromOptions(fileset, {
      baseOptions: { modelAssetPath: avatarTrackingConfig.modelAssetPath, delegate: delegate },
      runningMode: 'VIDEO',
      numFaces: 1,
      outputFaceBlendshapes: true,
      outputFacialTransformationMatrixes: false,
    });
  }

  async function loadAvatarFaceLandmarker() {
    if (avatarFaceLandmarker) return;
    setPerformanceStatus('Camera and microphone active. Loading face tracking…', false);
    if (avatarTestMode) {
      avatarFaceLandmarker = {
        detectForVideo: function () {
          var landmarks = [];
          landmarks[1] = { x: 0.5, y: 0.5 };
          landmarks[33] = { x: 0.4, y: 0.4 };
          landmarks[263] = { x: 0.6, y: 0.4 };
          landmarks[152] = { x: 0.5, y: 0.8 };
          return { faceLandmarks: [landmarks] };
        },
        close: function () {},
      };
      avatarWebcamReady = true;
      resetWebcamCalibration();
      refreshPerformanceUI();
      return;
    }
    try {
      avatarFaceLandmarker = await createAvatarFaceLandmarker('GPU');
    } catch (error) {
      avatarFaceLandmarker = await createAvatarFaceLandmarker('CPU');
    }
    avatarWebcamReady = true;
    resetWebcamCalibration();
    refreshPerformanceUI();
  }

  function updateTrackedPose(raw) {
    var calibration = avatarWebcamCalibration;
    if (!calibration) resetWebcamCalibration();
    calibration = avatarWebcamCalibration;
    if (avatarWebcamCalibrating) {
      calibration.x += raw.x;
      calibration.y += raw.y;
      calibration.roll += raw.roll;
      calibration.frames += 1;
      if (calibration.frames >= avatarTrackingConfig.calibrationFrames) {
        calibration.baseX = calibration.x / calibration.frames;
        calibration.baseY = calibration.y / calibration.frames;
        calibration.baseRoll = calibration.roll / calibration.frames;
        avatarWebcamCalibrating = false;
        setPerformanceStatus(hasAnimatedAvatar(portrait)
          ? 'Live control active. Face and microphone drive matched mouth and blink frames.'
          : 'Live control active. This static portrait follows pose only; build its animated pack for face motion.', false);
      }
      return;
    }
    var targetX = clamp(-(raw.x - calibration.baseX) * avatarTrackingConfig.yawGain, -1, 1);
    var targetY = clamp((raw.y - calibration.baseY) * avatarTrackingConfig.pitchGain, -1, 1);
    var targetRoll = clamp(raw.roll - calibration.baseRoll, -18, 18);
    avatarPose.x += (targetX - avatarPose.x) * 0.35;
    avatarPose.y += (targetY - avatarPose.y) * 0.35;
    avatarPose.roll += (targetRoll - avatarPose.roll) * 0.28;
  }

  function faceBlendshapeScore(blendshapes, name) {
    var categories = blendshapes && blendshapes.categories;
    if (!categories) return 0;
    for (var i = 0; i < categories.length; i += 1) {
      if (categories[i].categoryName === name) return Number(categories[i].score) || 0;
    }
    return 0;
  }

  function updateTrackedExpression(blendshapes) {
    var jawOpen = faceBlendshapeScore(blendshapes, 'jawOpen');
    var blink = Math.max(
      faceBlendshapeScore(blendshapes, 'eyeBlinkLeft'),
      faceBlendshapeScore(blendshapes, 'eyeBlinkRight')
    );
    avatarTrackedMouthLevel += (clamp(jawOpen * 1.45, 0, 1) - avatarTrackedMouthLevel) * 0.48;
    avatarTrackedBlink = blink >= 0.58;
  }

  function avatarWebcamTick() {
    avatarWebcamFrame = 0;
    if (!avatarWebcamRunning) return;
    var video = byID('tc-webcam');
    if (avatarWebcamReady && avatarFaceLandmarker && video.readyState >= 2 && video.videoWidth && video.currentTime !== avatarWebcamLastTime) {
      avatarWebcamLastTime = video.currentTime;
      try {
        var result = avatarFaceLandmarker.detectForVideo(video, performance.now());
        var landmarks = result && result.faceLandmarks && result.faceLandmarks[0];
        if (landmarks) {
          avatarWebcamLastSeen = performance.now();
          var pose = facePoseFromLandmarks(landmarks);
          if (pose) updateTrackedPose(pose);
          updateTrackedExpression(result && result.faceBlendshapes && result.faceBlendshapes[0]);
        } else if (performance.now() - avatarWebcamLastSeen > 800) {
          avatarPose.x *= 0.85;
          avatarPose.y *= 0.85;
          avatarPose.roll *= 0.85;
          avatarTrackedMouthLevel *= 0.8;
          avatarTrackedBlink = false;
          setPerformanceStatus('Camera and microphone active. Move into the camera frame.', false);
        }
      } catch (error) {
        setPerformanceStatus('Face tracking paused. Webcam and microphone remain active.', true);
      }
    }
    avatarWebcamFrame = window.requestAnimationFrame(avatarWebcamTick);
  }

  function connectAvatarMicrophone(stream) {
    if (!ensureAvatarAudioContext()) return;
    avatarMicSource = avatarAudioContext.createMediaStreamSource(stream);
    avatarMicAnalyser = avatarAudioContext.createAnalyser();
    avatarMicAnalyser.fftSize = 512;
    avatarMicAnalyser.smoothingTimeConstant = 0.2;
    avatarMicSource.connect(avatarMicAnalyser);
    avatarMicAnalyser.connect(avatarRecordDestination);
    avatarMicBuffer = new Uint8Array(avatarMicAnalyser.fftSize);
  }

  async function startAvatarPerformance() {
    if (!portrait) {
      setPerformanceStatus('Choose a character first.', true);
      return;
    }
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
      setPerformanceStatus('Webcam control requires HTTPS or localhost and a supported browser.', true);
      return;
    }
    byID('tc-performance-start').disabled = true;
    setPerformanceStatus('Requesting camera and microphone access…', false);
    try {
      avatarWebcamStream = await navigator.mediaDevices.getUserMedia({
        video: { width: { ideal: 640 }, height: { ideal: 480 }, facingMode: 'user' },
        audio: { echoCancellation: false, noiseSuppression: false, autoGainControl: false },
      });
      var video = byID('tc-webcam');
      video.srcObject = avatarWebcamStream;
      await video.play();
      connectAvatarMicrophone(avatarWebcamStream);
      avatarWebcamRunning = true;
      avatarWebcamLastTime = -1;
      avatarWebcamLastSeen = performance.now();
      avatarAudioReactive = true;
      avatarTalking = true;
      avatarFixed = false;
      ensureAvatarLoop();
      refreshPerformanceUI();
      avatarWebcamTick();
      await loadAvatarFaceLandmarker();
    } catch (error) {
      stopAvatarPerformance();
      setPerformanceStatus(error && error.message ? error.message : 'Camera or microphone access failed.', true);
    }
  }

  function stopAvatarPerformance() {
    if (performanceRecorder && performanceRecorder.state === 'recording') stopPerformanceRecording();
    avatarWebcamRunning = false;
    avatarWebcamReady = false;
    avatarWebcamCalibrating = false;
    window.cancelAnimationFrame(avatarWebcamFrame);
    avatarWebcamFrame = 0;
    if (avatarFaceLandmarker) {
      try { avatarFaceLandmarker.close(); } catch (error) {}
    }
    avatarFaceLandmarker = null;
    if (avatarMicSource) {
      try { avatarMicSource.disconnect(); } catch (error) {}
    }
    if (avatarMicAnalyser) {
      try { avatarMicAnalyser.disconnect(); } catch (error) {}
    }
    avatarMicSource = null;
    avatarMicAnalyser = null;
    avatarMicBuffer = null;
    if (avatarWebcamStream) avatarWebcamStream.getTracks().forEach(function (track) { track.stop(); });
    avatarWebcamStream = null;
    byID('tc-webcam').srcObject = null;
    avatarPose = { x: 0, y: 0, roll: 0 };
    avatarTrackedMouthLevel = 0;
    avatarTrackedBlink = false;
    stopAvatarTalk();
    refreshPerformanceUI();
    setPerformanceStatus('Camera and microphone stopped.', false);
  }

  function drawPerformanceFrame(timestamp) {
    var canvas = byID('tc-record-canvas');
    var context = canvas.getContext('2d');
    var width = canvas.width;
    var height = canvas.height;
    context.clearRect(0, 0, width, height);
    var background = context.createRadialGradient(width * 0.5, height * 0.3, 20, width * 0.5, height * 0.45, width * 0.7);
    background.addColorStop(0, '#202b4c');
    background.addColorStop(1, '#080b12');
    context.fillStyle = background;
    context.fillRect(0, 0, width, height);
    var visibleImage = byID('tc-narrator-img');
    var image = visibleImage && performanceImages[visibleImage.dataset.frameUrl];
    if (image && image.complete && image.naturalWidth) {
      var fit = Math.min(width / image.naturalWidth, height / image.naturalHeight) * 0.94;
      var drawWidth = image.naturalWidth * fit;
      var drawHeight = image.naturalHeight * fit;
      var speech = Math.sin(timestamp / 74) * avatarVoiceLevel;
      context.save();
      context.translate(width * 0.5 + avatarPose.x * 42 + speech * 8, height * 0.5 + avatarPose.y * 34 - Math.abs(speech) * 22);
      context.rotate((avatarPose.roll * 0.7 + avatarPose.x * 3.4 + speech * 1.15) * Math.PI / 180);
      var scale = 1 + avatarVoiceLevel * 0.026 + Math.abs(avatarPose.x) * 0.012;
      context.scale(scale, scale);
      try { context.drawImage(image, -drawWidth * 0.5, -drawHeight * 0.5, drawWidth, drawHeight); } catch (error) {}
      context.restore();
    }
    if (performanceRecorder && performanceRecorder.state === 'recording') {
      performanceFrame = window.requestAnimationFrame(drawPerformanceFrame);
    }
  }

  function performanceMimeType() {
    var candidates = ['video/webm;codecs=vp9,opus', 'video/webm;codecs=vp8,opus', 'video/webm'];
    if (!window.MediaRecorder) return '';
    if (!MediaRecorder.isTypeSupported) return candidates[candidates.length - 1];
    return candidates.filter(function (type) { return MediaRecorder.isTypeSupported(type); })[0] || '';
  }

  function preparePerformanceImages() {
    var urls = [portrait && portrait.image_url];
    if (portrait && portrait.assets) {
      avatarAssetKeys.forEach(function (key) { urls.push(portrait.assets[key]); });
    }
    urls = urls.filter(function (url, index, values) { return url && values.indexOf(url) === index; });
    return Promise.all(urls.map(function (url) {
      if (performanceImages[url] && performanceImages[url].complete) return performanceImages[url];
      return new Promise(function (resolve, reject) {
        var image = new Image();
        image.crossOrigin = 'anonymous';
        image.onload = function () {
          performanceImages[url] = image;
          resolve(image);
        };
        image.onerror = function () { reject(new Error('Character art does not allow browser video export. Build and save the transparent pack first.')); };
        var absolute = new URL(url, window.location.href);
        image.src = absolute.origin === window.location.origin
          ? absolute.href
          : '/api/img-proxy?url=' + encodeURIComponent(absolute.href);
      });
    }));
  }

  function finishPerformanceExport(mime) {
    performanceStream.getTracks().forEach(function (track) { track.stop(); });
    performanceStream = null;
    if (!performanceChunks.length) {
      setPerformanceStatus('No video data was recorded.', true);
      refreshPerformanceUI();
      return;
    }
    if (performanceURL) URL.revokeObjectURL(performanceURL);
    performanceURL = URL.createObjectURL(new Blob(performanceChunks, { type: mime || 'video/webm' }));
    var video = byID('tc-performance-video');
    video.src = performanceURL;
    var link = byID('tc-performance-download');
    link.href = performanceURL;
    link.download = 'talking-avatar-performance-' + Date.now() + '.webm';
    byID('tc-performance-result').classList.add('tc-on');
    setPerformanceStatus('Performance recorded. Preview or export the WebM video.', false);
    performanceRecorder = null;
    refreshPerformanceUI();
  }

  async function startPerformanceRecording() {
    if (!avatarWebcamRunning || !portrait) return;
    var canvas = byID('tc-record-canvas');
    var mime = performanceMimeType();
    if (!mime || !canvas.captureStream) {
      setPerformanceStatus('Video recording is unavailable in this browser.', true);
      return;
    }
    byID('tc-performance-record').disabled = true;
    setPerformanceStatus('Preparing character frames for video export…', false);
    try {
      await preparePerformanceImages();
      drawPerformanceFrame(performance.now());
      performanceStream = canvas.captureStream(30);
      var audioTrack = avatarRecordDestination && avatarRecordDestination.stream.getAudioTracks()[0];
      if (!audioTrack && avatarWebcamStream) audioTrack = avatarWebcamStream.getAudioTracks()[0];
      if (audioTrack) performanceStream.addTrack(audioTrack.clone());
      performanceRecorder = new MediaRecorder(performanceStream, { mimeType: mime });
      performanceChunks = [];
      performanceRecorder.ondataavailable = function (event) {
        if (event.data && event.data.size) performanceChunks.push(event.data);
      };
      performanceRecorder.onerror = function () {
        setPerformanceStatus('Performance recording failed.', true);
      };
      performanceRecorder.onstop = function () { finishPerformanceExport(mime); };
      performanceRecorder.start(250);
      window.cancelAnimationFrame(performanceFrame);
      performanceFrame = window.requestAnimationFrame(drawPerformanceFrame);
      setPerformanceStatus('Recording webcam movement, PNG animation and microphone audio…', false);
      refreshPerformanceUI();
    } catch (error) {
      if (performanceStream) performanceStream.getTracks().forEach(function (track) { track.stop(); });
      performanceStream = null;
      performanceRecorder = null;
      setPerformanceStatus(error && error.message ? error.message : 'Performance recording failed.', true);
      refreshPerformanceUI();
    }
  }

  function stopPerformanceRecording() {
    if (!performanceRecorder || performanceRecorder.state !== 'recording') return;
    window.cancelAnimationFrame(performanceFrame);
    performanceFrame = 0;
    performanceRecorder.stop();
    refreshPerformanceUI();
  }

  function togglePerformanceRecording() {
    if (performanceRecorder && performanceRecorder.state === 'recording') stopPerformanceRecording();
    else startPerformanceRecording();
  }

  function setAvatarTestState(state) {
    stopAvatarTalk();
    window.clearTimeout(avatarBlinkTimer);
    avatarFixed = true;
    window.cancelAnimationFrame(avatarFrame);
    avatarFrame = 0;
    var webcamState = state === 'webcam-left' || state === 'webcam-right' || state === 'recording';
    avatarPose = state === 'webcam-left'
      ? { x: -0.72, y: 0.18, roll: -7 }
      : state === 'webcam-right'
        ? { x: 0.72, y: -0.12, roll: 7 }
        : state === 'recording'
          ? { x: 0.28, y: 0.08, roll: 2 }
          : { x: 0, y: 0, roll: 0 };
	avatarBlinking = state === 'blink' || state === 'blink-half' || state === 'blink-open';
	avatarMouthShape = state === 'talk-open' || state === 'blink-open' || state === 'recording' ? 'open' : state === 'talk-half' || state === 'blink-half' || webcamState ? 'half' : 'closed';
    renderAvatarExpression();
    var level = state === 'talk-open' || state === 'recording' ? 1 : state === 'talk-half' || webcamState ? 0.42 : 0;
    document.querySelectorAll('.tc-avatar-motion').forEach(function (node) {
      node.style.transition = 'none';
    });
    setAvatarMotion(level, state === 'talk-open' ? 1850 : state === 'talk-half' ? 1380 : 0);
    ['tc-avatar-stage', 'tc-narrator-stage'].forEach(function (id) {
      var stage = byID(id);
      if (stage) {
        stage.dataset.testState = state;
        stage.dataset.webcam = webcamState ? 'true' : 'false';
      }
    });
    byID('tc-performance-record').classList.toggle('tc-recording', state === 'recording');
    byID('tc-performance-record').textContent = state === 'recording' ? 'Stop & export' : 'Record performance';
    byID('tc-performance-start').disabled = webcamState;
    byID('tc-performance-start').textContent = webcamState ? 'Webcam active' : 'Start webcam + mic';
    byID('tc-performance-calibrate').disabled = !webcamState;
    byID('tc-performance-record').disabled = !webcamState;
    byID('tc-performance-stop').disabled = !webcamState;
    byID('tc-narrator-demo').disabled = webcamState;
    if (webcamState) setPerformanceStatus(state === 'recording' ? 'Recording webcam movement, PNG animation and microphone audio…' : 'Live control active. Head movement and microphone level drive the avatar.', false);
  }

  function setAvatarTestPose(x, y, roll) {
    avatarPose = { x: clamp(Number(x) || 0, -1, 1), y: clamp(Number(y) || 0, -1, 1), roll: clamp(Number(roll) || 0, -18, 18) };
    avatarFixed = true;
    setAvatarMotion(avatarVoiceLevel, 0);
  }

  function testAvatarPortrait() {
	var base = '/static/characters/portraits/featured/vesper-nyx/';
    return {
	  slug: 'test-png-avatar', name: 'PNG Avatar Test', image_url: base + 'eyes_open_mouth_closed.webp', source: 'test',
      assets: {
		eyes_open_mouth_closed: base + 'eyes_open_mouth_closed.webp',
		eyes_open_mouth_half: base + 'eyes_open_mouth_half.webp',
		eyes_open_mouth_open: base + 'eyes_open_mouth_open.webp',
		eyes_closed_mouth_closed: base + 'eyes_closed_mouth_closed.webp',
		eyes_closed_mouth_half: base + 'eyes_closed_mouth_half.webp',
		eyes_closed_mouth_open: base + 'eyes_closed_mouth_open.webp',
      },
    };
  }

  function resetAvatarTest() {
	if (avatarWebcamRunning) stopAvatarPerformance();
	stopAvatarTalk();
	window.clearTimeout(avatarBlinkTimer);
	var fixture = testAvatarPortrait();
	if (!portrait || portrait.slug !== fixture.slug) selectPortrait(fixture);
	setAvatarTestState('idle');
	return avatarSnapshot();
  }

  function avatarSnapshot() {
    var image = byID('tc-narrator-img');
    var stage = byID('tc-narrator-stage');
    var motion = stage && stage.querySelector('.tc-avatar-motion');
    return {
      expression: image && image.dataset.expression,
      src: image && image.getAttribute('src'),
      transform: motion && ['--tc-x', '--tc-y', '--tc-tilt', '--tc-scale'].map(function (key) {
        return motion.style.getPropertyValue(key);
      }).join(' '),
      level: motion && Number(motion.dataset.level || 0),
      pose: motion && motion.dataset.pose,
      webcam: stage && stage.dataset.webcam === 'true',
      recording: byID('tc-performance-record').classList.contains('tc-recording'),
	  ready: hasAnimatedAvatar(portrait),
	  name: portrait && portrait.name,
	  buildHidden: byID('tc-narrator-build').hidden,
	  transitionPending: !!(stage && stage.classList.contains('tc-avatar-changing')),
	  complete: !!(image && image.complete && image.naturalWidth),
    };
  }

  function openNarrator() {
    if (!portrait) return;
    refreshAvatarUI();
    renderAvatarExpression();
    var dialog = byID('tc-narrator');
    if (dialog && !dialog.open) dialog.showModal();
  }

  function portraitCard(item) {
    var card = document.createElement('figure');
    card.className = 'tc-card';
    card.dataset.slug = item.slug || '';
    card.dataset.variantKey = avatarVariantKey(item);
    var img = document.createElement('img');
    img.loading = 'lazy';
    img.decoding = 'async';
    img.alt = item.name || 'Character portrait';
    img.src = item.image_url;
    img.addEventListener('error', function () {
      card.remove();
    });
    var caption = document.createElement('figcaption');
    caption.textContent = item.name || item.slug;
    var state = document.createElement('span');
    var kind = hasVideoAvatar(item) ? 'Video' : hasAnimatedAvatar(item) ? 'Animated' : 'Portrait';
    state.className = 'tc-card-state' + (kind !== 'Portrait' ? ' tc-ready' : '') + (item.nsfw ? ' tc-mature' : '');
    state.textContent = (item.nsfw ? 'Mature · ' : '') + kind;
    card.append(img, caption, state);
    card.addEventListener('click', function () {
      selectPortrait(item);
      openNarrator();
    });
    return card;
  }

  function renderStyles(styles) {
    var host = byID('tc-style-chips');
    if (!host || host.dataset.ready === '1' || !styles.length) return;
    host.dataset.ready = '1';
    var all = document.createElement('button');
    all.type = 'button';
    all.className = 'tc-chip tc-on';
    all.textContent = 'All styles';
    all.dataset.style = '';
    host.appendChild(all);
    styles.forEach(function (style) {
      var chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'tc-chip';
      chip.textContent = style.name;
      chip.dataset.style = style.id;
      host.appendChild(chip);
    });
    host.addEventListener('click', function (event) {
      var chip = event.target.closest('.tc-chip');
      if (!chip) return;
      styleFilter = chip.dataset.style || '';
      host.querySelectorAll('.tc-chip').forEach(function (node) {
        node.classList.toggle('tc-on', node === chip);
      });
      loadPortraits();
    });
  }

  function galleryMore(id, gallery, hasMore, loadMore) {
    if (!gallery) return;
    var more = byID(id);
    if (!more) {
      more = document.createElement('button');
      more.type = 'button';
      more.id = id;
      more.className = 'tc-more';
      more.textContent = 'Load more avatars';
      more.style.cssText = 'display:block;width:100%;margin:12px 0 0;padding:10px;border:0;border-radius:8px;background:#2a2a32;color:#fff;cursor:pointer';
      gallery.after(more);
      more.addEventListener('click', function () { loadMore(true); });
    }
    more.hidden = !hasMore;
    more.disabled = false;
  }

  async function loadPortraits(append) {
    var gallery = byID('tc-gallery');
    if (!gallery || portraitPage.loading) return;
    if (append && portraitPage.done) return;
    var query = byID('tc-portrait-search').value.trim();
    if (!append) {
      portraitPage.offset = 0;
      portraitPage.done = false;
    }
    portraitPage.loading = true;
    var limit = 48;
    var url = '/api/search-prepared-avatars?limit=' + limit + '&offset=' + portraitPage.offset + '&query=' + encodeURIComponent(query);
    try {
      var response = await fetch(url, { credentials: 'same-origin' });
      if (response.status === 404) {
        response = await fetch('/api/character-portraits?kind=avatars&limit=' + limit + '&offset=' + portraitPage.offset + '&query=' + encodeURIComponent(query), { credentials: 'same-origin' });
      }
      if (!response.ok) throw new Error('portrait search unavailable');
      var data = await response.json();
      var items = (Array.isArray(data.avatars) ? data.avatars : Array.isArray(data.portraits) ? data.portraits : []).reduce(function (variants, item) {
        return variants.concat(avatarResultVariants(item));
      }, []);
      renderStyles(Array.isArray(data.styles) ? data.styles : []);
      portraitPage.total = Number(data.total || 0);
      byID('tc-portrait-count').textContent = portraitPage.total.toLocaleString() + ' ready avatars';
      if (!append) gallery.replaceChildren();
      if (!items.length && !append) {
        var empty = document.createElement('div');
        empty.className = 'tc-empty';
        empty.textContent = 'No completed avatars match. Make a new avatar from art or a prompt.';
        gallery.appendChild(empty);
        galleryMore('tc-portrait-more', gallery, false, loadPortraits);
        return;
      }
      items.forEach(function (item) {
        gallery.appendChild(portraitCard(item));
      });
      portraitPage.offset += Array.isArray(data.avatars) ? data.avatars.length : Array.isArray(data.portraits) ? data.portraits.length : items.length;
      portraitPage.done = data.has_more === false || portraitPage.offset >= portraitPage.total || items.length === 0;
      galleryMore('tc-portrait-more', gallery, !portraitPage.done, loadPortraits);
      if (!portrait && items[0]) selectPortrait(items[0]);
      if (portrait) {
        var selected = Array.from(gallery.querySelectorAll('.tc-card')).filter(function (card) {
          return card.dataset.variantKey === avatarVariantKey(portrait);
        })[0];
        if (selected) selected.classList.add('tc-on');
      }
    } catch (error) {
      if (!append) {
        gallery.replaceChildren();
        var failed = document.createElement('div');
        failed.className = 'tc-empty';
        failed.textContent = 'Ready avatar search is temporarily unavailable. Make a new avatar to keep going.';
        gallery.appendChild(failed);
      }
    } finally {
      portraitPage.loading = false;
    }
  }

  async function loadSourcePortraits(append) {
    var gallery = byID('tc-source-gallery');
    var input = byID('tc-source-search');
    if (!gallery || !input || sourcePage.loading) return;
    if (append && sourcePage.done) return;
    var query = input.value.trim();
    if (!append) {
      sourcePage.offset = 0;
      sourcePage.done = false;
    }
    sourcePage.loading = true;
    var limit = 48;
    var url = '/api/character-portraits?kind=sources&limit=' + limit + '&offset=' + sourcePage.offset + '&query=' + encodeURIComponent(query);
    try {
      var response = await fetch(url, { credentials: 'same-origin' });
      if (!response.ok) throw new Error('source art search unavailable');
      var data = await response.json();
      var items = (Array.isArray(data.portraits) ? data.portraits : []).filter(function (item) { return !hasAnimatedAvatar(item); });
      sourcePage.total = Number(data.total || 0);
      if (!append) gallery.replaceChildren();
      if (!items.length && !append) {
        var empty = document.createElement('div');
        empty.className = 'tc-empty';
        empty.textContent = 'No source art matches. Generate from the prompt below or upload an image.';
        gallery.appendChild(empty);
        galleryMore('tc-source-more', gallery, false, loadSourcePortraits);
        return;
      }
      items.forEach(function (item) { gallery.appendChild(portraitCard(item)); });
      sourcePage.offset += (Array.isArray(data.portraits) ? data.portraits.length : items.length);
      sourcePage.done = data.has_more === false || sourcePage.offset >= sourcePage.total || items.length === 0;
      galleryMore('tc-source-more', gallery, !sourcePage.done, loadSourcePortraits);
    } catch (error) {
      if (!append) {
        gallery.replaceChildren();
        var failed = document.createElement('div');
        failed.className = 'tc-empty';
        failed.textContent = 'Source art search is temporarily unavailable. Generate or upload an image instead.';
        gallery.appendChild(failed);
      }
    } finally {
      sourcePage.loading = false;
    }
  }

  function voiceCard(asset) {
    var card = document.createElement('button');
    card.type = 'button';
    card.className = 'tc-voice';
    card.dataset.key = voiceKey(asset);
    var name = document.createElement('strong');
    name.textContent = asset.title;
    var description = document.createElement('small');
    description.textContent = asset.description || (asset.tags || []).slice(0, 4).join(', ');
    var provider = document.createElement('em');
    provider.textContent = asset.provider || 'voice';
    card.append(name, description, provider);
    card.addEventListener('click', function () {
      selectVoice(asset);
    });
    return card;
  }

  function voiceKey(asset) {
    var url = asset.url || '';
    var file = url.split('/').pop() || '';
    return file.replace(/\.(wav|opus|mp3)$/i, '');
  }

  function selectVoice(asset) {
    voice = asset;
    customVoiceURL = '';
    document.querySelectorAll('.tc-voice').forEach(function (node) {
      node.classList.toggle('tc-on', node.dataset.key === voiceKey(asset));
    });
    var player = byID('tc-voice-preview');
    player.crossOrigin = 'anonymous';
    player.src = asset.preview_url || asset.url;
    player.play().catch(function () {});
    setStatus('Voice set to ' + asset.title + '.', false);
  }

  async function loadVoices() {
    var host = byID('tc-voices');
    var query = [byID('tc-voice-search').value.trim(), voiceFilter].filter(Boolean).join(' ');
    try {
      var response = await fetch('/api/search-audio?kind=voice&limit=80&query=' + encodeURIComponent(query), {
        credentials: 'same-origin',
      });
      if (!response.ok) throw new Error('voice search unavailable');
      var assets = await response.json();
      host.replaceChildren();
      if (!Array.isArray(assets) || !assets.length) {
        var empty = document.createElement('div');
        empty.className = 'tc-empty';
        empty.textContent = 'No voices match. Upload or record a reference instead.';
        host.appendChild(empty);
        return;
      }
      assets.forEach(function (asset) {
        host.appendChild(voiceCard(asset));
      });
      if (voice) {
        var selected = host.querySelector('[data-key="' + voiceKey(voice) + '"]');
        if (selected) selected.classList.add('tc-on');
      }
    } catch (error) {
      host.replaceChildren();
      var failed = document.createElement('div');
      failed.className = 'tc-empty';
      failed.textContent = 'Voice search is temporarily unavailable. Upload a reference sample to keep going.';
      host.appendChild(failed);
    }
  }

  function renderBackends() {
    var host = byID('tc-backends');
    host.replaceChildren();
    backends.forEach(function (item) {
      var row = document.createElement('label');
      row.className = 'tc-backend' + (backend && backend.id === item.id ? ' tc-on' : '');
      row.dataset.id = item.id;
      var radio = document.createElement('input');
      radio.type = 'radio';
      radio.name = 'tc-backend';
      radio.value = item.id;
      radio.checked = !!(backend && backend.id === item.id);
      var text = document.createElement('div');
      var name = document.createElement('strong');
      name.textContent = item.label;
      var description = document.createElement('small');
      description.textContent = item.description;
      text.append(name, description);
      var price = document.createElement('b');
      price.textContent = Math.max(1, Math.ceil(item.usd_per_second * 1.2 * 100)) + ' cr/s';
      row.append(radio, text, price);
      row.addEventListener('click', function () {
        backend = item;
        renderBackends();
        byID('tc-video-field').hidden = item.input !== 'video';
        refreshEstimate();
      });
      host.appendChild(row);
    });
  }

  function renderDefaultCharacters() {
    var host = byID('tc-default-characters');
    if (!host) return;
    host.replaceChildren();
    defaultCharacters.forEach(function (character) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'tc-default';
      var name = document.createElement('strong');
      name.textContent = character.name;
      var prompt = document.createElement('small');
      prompt.textContent = character.prompt;
      button.append(name, prompt);
      button.addEventListener('click', function () {
        byID('tc-generate-name').value = character.name || '';
        byID('tc-generate-prompt').value = character.prompt || '';
        byID('tc-generate-greeting').value = character.greeting || '';
		if (character.framing) byID('tc-generate-framing').value = character.framing;
		refreshAvatarCreationPricing();
        if (character.style_id) {
          byID('tc-generate-style').dataset.pendingValue = character.style_id;
          byID('tc-generate-style').value = character.style_id;
        }
      });
      host.appendChild(button);
    });
  }

  async function loadBackends() {
    try {
      var response = await fetch('/api/talking-character/backends', { credentials: 'same-origin' });
      if (!response.ok) throw new Error('backends unavailable');
      var data = await response.json();
      backends = Array.isArray(data.backends) ? data.backends : [];
      defaultCharacters = Array.isArray(data.default_characters) ? data.default_characters : [];
      renderDefaultCharacters();
      if (data.avatar_pack && data.avatar_pack.credits) {
        avatarPackCredits = data.avatar_pack.credits;
        byID('tc-build-avatar').textContent = 'Build transparent animated avatar pack & save · up to ' + avatarPackCredits + ' credits';
		refreshAvatarCreationPricing();
        refreshAvatarUI();
      }
      if (data.avatar_pack && data.avatar_pack.video_credits) {
        avatarVideoCredits = data.avatar_pack.video_credits;
        var videoPrice = byID('tc-video-avatar-price');
        if (videoPrice) videoPrice.textContent = 'Idle + talking 15s H3 clips cost ' + avatarVideoCredits + ' credits, greenscreen then background removal.';
        refreshAvatarUI();
      }
      backend = backends.filter(function (item) {
        return item.default;
      })[0] || backends[0] || null;
      renderBackends();
      if (backend) byID('tc-video-field').hidden = backend.input !== 'video';
      refreshEstimate();
    } catch (error) {
      setStatus('Could not load animation models.', true);
    }
  }

	function refreshAvatarCreationPricing() {
		var framing = byID('tc-generate-framing') && byID('tc-generate-framing').value;
		var imageCredits = framing === 'full_body' ? 8 : 4;
		byID('tc-generate-portrait').textContent = (framing === 'full_body' ? 'Generate full-body character' : 'Generate portrait') + ' · ' + imageCredits + ' credits';
		byID('tc-generate-full').textContent = 'Generate complete talking character · up to ' + (avatarPackCredits + imageCredits) + ' credits';
	}

  async function uploadFile(file, prefix, fallbackExtension) {
    var extension = (file.name.split('.').pop() || fallbackExtension).toLowerCase();
    var signed = await window.getSignedURLAndUpload(file, file.type, prefix + '-' + Date.now() + '.' + extension);
    var bucket = signed.bucket_name || 'netwrckstatic.netwrck.com';
    return 'https://' + bucket + '/' + signed.object_path;
  }

  async function handlePortraitUpload(file) {
    if (!file) return;
    setStatus('Uploading portrait…', false);
    try {
      var url = await uploadFile(file, 'talking-portrait', 'webp');
      selectPortrait({ slug: '', name: file.name, image_url: url, source: 'upload' });
      setStatus('Portrait uploaded.', false);
    } catch (error) {
      setStatus('Portrait upload failed.', true);
    }
  }

  async function handleVoiceUpload(file) {
    if (!file) return;
    setStatus('Uploading voice reference…', false);
    try {
      customVoiceURL = await uploadFile(file, 'talking-voice', 'webm');
      voice = null;
      document.querySelectorAll('.tc-voice').forEach(function (node) {
        node.classList.remove('tc-on');
      });
      setStatus('Custom voice reference ready.', false);
    } catch (error) {
      setStatus('Voice upload failed.', true);
    }
  }

  function stopRecording() {
    if (!recorder || !recording) return;
    recorder.stop();
    recorder.stream.getTracks().forEach(function (track) {
      track.stop();
    });
    recording = false;
    byID('tc-record').textContent = 'Record 12s';
  }

  async function toggleRecording() {
    if (recording) {
      stopRecording();
      return;
    }
    try {
      var stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      recorder = new MediaRecorder(stream);
      recordingChunks = [];
      recorder.ondataavailable = function (event) {
        if (event.data.size) recordingChunks.push(event.data);
      };
      recorder.onstop = function () {
        var blob = new Blob(recordingChunks, { type: recorder.mimeType || 'audio/webm' });
        handleVoiceUpload(new File([blob], 'talking-voice.webm', { type: blob.type }));
      };
      recorder.start();
      recording = true;
      byID('tc-record').textContent = 'Stop recording';
      window.setTimeout(stopRecording, 12000);
    } catch (error) {
      setStatus('Microphone access failed. Upload a sample instead.', true);
    }
  }

  async function generatePortrait(fullPipeline) {
    fullPipeline = fullPipeline === true;
    var prompt = byID('tc-generate-prompt').value.trim();
    var characterName = byID('tc-generate-name').value.trim();
    if (!prompt) {
      byID('tc-generate-status').textContent = 'Describe the character first.';
      return;
    }
    if (fullPipeline && !characterName) {
      byID('tc-generate-status').textContent = 'Name the character before running the complete pipeline.';
      return;
    }
    var secret = credentials();
    if (!secret || secret === 'anonymous') {
      requireLogin();
      return;
    }
    byID('tc-generate-portrait').disabled = true;
    byID('tc-generate-full').disabled = true;
    byID('tc-generate-status').textContent = fullPipeline ? 'Generating portrait art for the complete character…' : 'Generating portrait…';
    try {
		var framing = byID('tc-generate-framing').value || 'portrait';
		var source = byID('tc-generate-source').value || '';
		var style = byID('tc-generate-style').value;
		var characterImageURL = '';
		var portraitURL = '';
		if (framing === 'full_body') {
			byID('tc-generate-status').textContent = 'Generating full-body character art…';
			characterImageURL = await requestCharacterImage(prompt, 'full_body', style, source, secret);
			if (fullPipeline) {
				byID('tc-generate-status').textContent = 'Full-body art ready. Generating its matching animation portrait…';
				portraitURL = await requestCharacterImage(prompt, 'portrait', style, source, secret);
			} else {
				portraitURL = characterImageURL;
			}
		} else {
			portraitURL = await requestCharacterImage(prompt, 'portrait', style, source, secret);
		}
		selectPortrait({
			slug: '',
			name: characterName || prompt.slice(0, 48),
			image_url: portraitURL,
			framing: fullPipeline ? 'portrait' : framing,
			assets: characterImageURL && fullPipeline ? { full_body: characterImageURL } : {},
			source: source || 'auto-local-first',
		});
      setAvatarBuildStatus(fullPipeline ? 'Portrait ready. Starting transparent frames, sheet and chat publishing…' : 'Portrait ready. Create the animated pack to save and search it here.', false);
      openNarrator();
      if (fullPipeline) await buildAvatarAssets({ publishCharacter: true });
    } catch (error) {
      byID('tc-generate-status').textContent = error.message || 'Portrait generation failed.';
    } finally {
      byID('tc-generate-portrait').disabled = false;
		byID('tc-generate-full').disabled = false;
    }
  }

	function characterImagePrompt(prompt, framing) {
		if (framing === 'full_body') {
			return prompt + ', one unmistakably adult character, full body standing portrait, head-to-toe complete silhouette, both feet visible, centered front-facing pose, face unobscured, eyes open, mouth closed, simple clean background, generous margin, no other people, no cropped limbs, no text, no watermark';
		}
		return prompt + ', one unmistakably adult character, head and shoulders portrait, exactly one face, centered front-facing pose, looking at the viewer, eyes open, mouth closed, neutral expression, shoulders level, face fills about 45 percent of the canvas, hands and props outside frame, clean flat background, no text, no watermark';
	}

	async function requestCharacterImage(prompt, framing, style, source, secret) {
		var body = {
			prompt: characterImagePrompt(prompt, framing),
			size: framing === 'full_body' ? 'portrait_2_3' : 'square',
			api_key: secret,
			secret: secret,
			num_images: 1,
		};
		if (style) body.lora_id = style;
		if (source) body.image_source = source;
		var response = await fetch('/api/ra1', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json', 'X-API-Key': secret, Authorization: 'Bearer ' + secret },
			credentials: 'include',
			body: JSON.stringify(body),
		});
		var data = await response.json().catch(function () { return {}; });
		if (!response.ok) {
			if (response.status === 401) requireLogin();
			if (handlePaymentRequired(response, data)) throw new Error(data.error || 'Insufficient credits.');
			throw new Error(data.error || 'Character image generation failed.');
		}
		var url = data.image_url || (Array.isArray(data.image_urls) ? data.image_urls[0] : '');
		if (!url) throw new Error('No character image returned.');
		return url;
	}

  function generatedAvatarTags() {
    var value = [byID('tc-generate-prompt').value, portrait && portrait.name, portrait && portrait.tags && portrait.tags.join(' ')]
      .filter(Boolean)
      .join(' ')
      .toLowerCase();
    var ignored = { a: true, an: true, the: true, with: true, and: true, portrait: true, character: true, head: true, shoulders: true };
    return value.split(/[^a-z0-9]+/).filter(function (word, index, words) {
      return word.length > 2 && !ignored[word] && words.indexOf(word) === index;
    }).slice(0, 8);
  }

	async function recoverPreparedAvatar(name) {
		var query = String(name || '').trim();
		if (!query) return null;
		try {
			var response = await fetch('/api/search-prepared-avatars?limit=12&query=' + encodeURIComponent(query), { credentials: 'same-origin' });
			if (response.status === 404) {
				response = await fetch('/api/character-portraits?kind=avatars&limit=12&query=' + encodeURIComponent(query), { credentials: 'same-origin' });
			}
			if (!response.ok) return null;
			var data = await response.json().catch(function () { return {}; });
			var items = (Array.isArray(data.avatars) ? data.avatars : Array.isArray(data.portraits) ? data.portraits : []).filter(hasAnimatedAvatar);
			var normalized = query.toLowerCase();
			return items.find(function (item) { return String(item.name || '').trim().toLowerCase() === normalized; }) || null;
		} catch (error) {
			return null;
		}
	}

	async function recoverAvatarJob(statusURL) {
		var jobID = String(statusURL || '').split('/').filter(Boolean).pop();
		if (!jobID) return null;
		try {
			var response = await fetch('/api/video-history?job_type=talking-avatar-assets&job_id=' + encodeURIComponent(jobID) + '&limit=1', { credentials: 'same-origin' });
			if (!response.ok) return null;
			var data = await response.json().catch(function () { return {}; });
			return (Array.isArray(data.jobs) ? data.jobs : []).find(function (job) { return job.job_id === jobID; }) || null;
		} catch (error) {
			return null;
		}
	}

	function finishRecoveredAvatar(item, publishCharacter) {
		selectPortrait(item);
		refreshAvatarUI();
		setAvatarBuildStatus(publishCharacter ? 'Aligned avatar ready. Chat character indexing is completing.' : 'Aligned PNG states and character sheet are ready.', false);
		setStatus('Animated avatar ready.', false);
		byID('tc-build-avatar').disabled = false;
		byID('tc-narrator-build').disabled = false;
		byID('tc-generate-full').disabled = false;
		loadPortraits();
	}

	  function pollAvatarAssets(statusURL, publishCharacter, avatarName, missingAttempts, historyOnly) {
    window.clearTimeout(pollTimer);
    pollTimer = window.setTimeout(async function () {
      try {
		var attempts = missingAttempts || 0;
		var response = null;
		var data = {};
		if (!historyOnly) {
			response = await fetch(statusURL, { credentials: 'same-origin' });
			data = await response.json().catch(function () { return {}; });
			historyOnly = response.status === 404;
		}
		if (historyOnly) {
			var historyJob = await recoverAvatarJob(statusURL);
			if (historyJob) {
				data = historyJob;
				response = { ok: true, status: 200 };
			}
			if (!historyJob && attempts >= 1) {
				  var recovered = await recoverPreparedAvatar(avatarName);
				  if (recovered) {
					  finishRecoveredAvatar(recovered, publishCharacter);
					  return;
				  }
			}
			var maxMissingAttempts = avatarTestMode ? 4 : 75;
	        if (!historyJob && attempts < maxMissingAttempts) {
				  setAvatarBuildStatus('Build is running; reconnecting through job history and the prepared-avatar index…', false);
				  pollAvatarAssets(statusURL, publishCharacter, avatarName, attempts + 1, true);
				  return;
			}
			if (!historyJob) throw new Error('The build status was lost. Check prepared avatars before retrying; reserved credits remain protected by the server job.');
		}
        if (!response.ok) throw new Error(data.error || 'Avatar build status is unavailable (' + response.status + ').');
        if (data.status === 'completed') {
          var result = data.result || {};
          if (!result.portrait || !result.portrait.image_url) throw new Error('Avatar frames were not returned.');
          selectPortrait(result.portrait);
          refreshAvatarUI();
          var published = !!result.ai_character;
          var localPack = result.expression_backend === 'liveportrait';
		  var allLocal = localPack && result.cutout_backend === 'omniserve-native';
          var refund = Number(data.credits_refunded || 0);
		  var backendMessage = allLocal ? 'All-local Omniserve cutout and LivePortrait pack saved.' : localPack ? 'LivePortrait batch saved.' : 'Flux Kontext fallback pack saved.';
		  if (result.emotion_backends) backendMessage += ' Emotion variants saved.';
		  if (result.emotion_error) backendMessage += ' Base pack saved; emotion variants can be retried.';
          if (refund > 0) backendMessage += ' ' + refund + ' credits refunded.';
          setAvatarBuildStatus(backendMessage + (published ? ' Chat character published and indexed.' : ' PNG states and character sheet are searchable.'), false);
          setStatus(published ? 'Talking character ready and searchable in chat.' : 'Animated avatar ready.', false);
          byID('tc-generate-full').disabled = false;
          loadPortraits();
          if (byID('tc-make-video') && byID('tc-make-video').checked) {
            convertVideoAvatar();
          }
          return;
        }
        if (data.status === 'failed') throw new Error(data.error || 'Avatar asset generation failed.');
        setAvatarBuildStatus('Building LivePortrait states and the selected Flux Kontext emotion sheet…', false);
	        pollAvatarAssets(statusURL, publishCharacter, avatarName, historyOnly ? attempts + 1 : 0, historyOnly);
      } catch (error) {
        setAvatarBuildStatus(error.message || 'Avatar asset generation failed.', true);
        byID('tc-build-avatar').disabled = false;
        byID('tc-narrator-build').disabled = false;
        byID('tc-generate-full').disabled = false;
      }
    }, avatarTestMode ? 40 : 4000);
  }

  async function buildAvatarAssets(options) {
    var publishCharacter = !!(options && options.publishCharacter === true);
    if (!portrait || !portrait.image_url) {
      setAvatarBuildStatus('Generate, upload or select a portrait first.', true);
      return;
    }
    var secret = credentials();
    if (!secret || secret === 'anonymous') {
      requireLogin();
      return;
    }
    var button = byID('tc-build-avatar');
    button.disabled = true;
    byID('tc-narrator-build').disabled = true;
    if (publishCharacter) byID('tc-generate-full').disabled = true;
    setAvatarBuildStatus('Submitting the neutral LivePortrait states and selected six-emotion pack…', false);
    try {
      var response = await fetch('/api/talking-avatar/assets', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({
          image_url: portrait.image_url,
		  character_image_url: portrait.assets && portrait.assets.full_body || '',
          name: portrait.name || 'Talking avatar',
          prompt: byID('tc-generate-prompt').value.trim() || portrait.name || '',
          greeting: byID('tc-generate-greeting').value.trim(),
          tags: generatedAvatarTags(),
          publish_character: publishCharacter,
          make_video: !!(byID('tc-make-video') && byID('tc-make-video').checked),
          emotions: emotionPacks[byID('tc-emotion-pack').value] || [],
        }),
      });
      var data = await response.json().catch(function () { return {}; });
      if (!response.ok) {
        if (response.status === 401) requireLogin();
        handlePaymentRequired(response, data);
        throw new Error(data.error || 'Avatar asset generation failed.');
      }
      setAvatarBuildStatus('Queued · up to ' + (data.credits_charged || 0) + ' credits reserved. Local completion refunds the unused fallback amount.', false);
	      pollAvatarAssets(data.status_url || '/api/fal/status/' + data.job_id, publishCharacter, portrait.name || 'Talking avatar', 0);
    } catch (error) {
      setAvatarBuildStatus(error.message || 'Avatar asset generation failed.', true);
      button.disabled = false;
      byID('tc-narrator-build').disabled = false;
      byID('tc-generate-full').disabled = false;
    }
  }

  async function convertVideoAvatar() {
    if (!portrait || !portrait.image_url) {
      setAvatarBuildStatus('Generate, upload or select a portrait first.', true);
      return;
    }
    var secret = credentials();
    if (!secret || secret === 'anonymous') {
      requireLogin();
      return;
    }
    var button = ensureVideoAvatarButton();
    if (button) button.disabled = true;
    setAvatarBuildStatus('Submitting 15s still-camera H3 with first=last frame and add_transparency…', false);
    try {
      var response = await fetch('/api/talking-avatar/video', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({
          image_url: portrait.image_url,
          name: portrait.name || 'Video avatar',
          prompt: byID('tc-generate-prompt').value.trim() || portrait.prompt || portrait.name || '',
          slug: portrait.slug || '',
        }),
      });
      var data = await response.json().catch(function () { return {}; });
      if (!response.ok) {
        if (response.status === 401) requireLogin();
        handlePaymentRequired(response, data);
        throw new Error(data.error || 'Video avatar generation failed.');
      }
      setAvatarBuildStatus('Queued video avatar · ' + (data.credits_charged || avatarVideoCredits) + ' credits. Polling opaque then transparent…', false);
      pollVideoAvatar(data.status_url || '/api/fal/status/' + data.job_id, 0);
    } catch (error) {
      setAvatarBuildStatus(error.message || 'Video avatar generation failed.', true);
      if (button) button.disabled = false;
    }
  }

  function pollVideoAvatar(statusURL, attempts) {
    window.setTimeout(async function () {
      try {
        var response = await fetch(statusURL, { credentials: 'include' });
        var data = await response.json().catch(function () { return {}; });
        if (!response.ok) throw new Error(data.error || 'Video avatar status is unavailable (' + response.status + ').');
        if (data.status === 'completed') {
          var result = data.result || {};
          if (result.portrait) selectPortrait(result.portrait);
          refreshAvatarUI();
          var opaque = result.opaque_video_url || '';
          var transparent = result.transparent_video_url || (result.portrait && result.portrait.assets && result.portrait.assets.video_loop) || '';
          setAvatarBuildStatus('Video avatar saved. Opaque and transparent clips are in the pack' + (transparent ? '.' : ' (transparent URL missing).'), !transparent);
          setStatus('Video avatar ready. Chat uses the original looping video.', false);
          if (byID('tc-result') && (opaque || transparent)) {
            showResult(transparent || opaque);
          }
          loadPortraits();
          return;
        }
        if (data.status === 'failed') throw new Error(data.error || 'Video avatar generation failed.');
        var progress = data.progress != null ? ' · ' + data.progress + '%' : '';
        setAvatarBuildStatus('Generating still-camera talking clip, then MatAnyone transparency' + progress + '…', false);
        pollVideoAvatar(statusURL, (attempts || 0) + 1);
      } catch (error) {
        setAvatarBuildStatus(error.message || 'Video avatar generation failed.', true);
        var button = ensureVideoAvatarButton();
        if (button) button.disabled = false;
      }
    }, avatarTestMode ? 40 : 4000);
  }

  async function loadStyleOptions() {
    var select = byID('tc-generate-style');
    if (!select) return;
    var auto = document.createElement('option');
    auto.value = '';
    auto.textContent = 'Auto (match the prompt)';
    select.appendChild(auto);
    try {
      var response = await fetch('/api/ra1/loras', { credentials: 'same-origin' });
      if (!response.ok) return;
      var data = await response.json();
      var loras = Array.isArray(data) ? data : data.loras || [];
      loras.slice(0, 120).forEach(function (lora) {
        var option = document.createElement('option');
        option.value = lora.id || lora.ID || '';
        option.textContent = lora.name || lora.Name || option.value;
        if (option.value) select.appendChild(option);
      });
      if (select.dataset.pendingValue) select.value = select.dataset.pendingValue;
    } catch (error) {
      /* auto only */
    }
  }

  function showResult(url) {
    byID('tc-video').src = url;
    byID('tc-download').href = url;
    byID('tc-result').classList.add('tc-on');
  }

  function videoURLFrom(result) {
    if (!result || typeof result !== 'object') return '';
    if (typeof result.video_url === 'string') return result.video_url;
    if (result.video && typeof result.video.url === 'string') return result.video.url;
    if (result.result) return videoURLFrom(result.result);
    return '';
  }

  function pollJob(jobID) {
    window.clearTimeout(pollTimer);
    pollTimer = window.setTimeout(async function () {
      try {
        var response = await fetch('/api/fal/status/' + jobID, { credentials: 'same-origin' });
        var data = await response.json().catch(function () {
          return {};
        });
        if (data.status === 'completed') {
          var url = videoURLFrom(data.result) || videoURLFrom(data);
          if (!url) throw new Error('No video returned.');
          showResult(url);
          setStatus('Talking character ready.', false);
          byID('tc-progress').hidden = true;
          byID('tc-generate').disabled = false;
          return;
        }
        if (data.status === 'failed') {
          throw new Error(data.error || 'Generation failed.');
        }
        setStatus('Rendering… this usually takes a few minutes.', false);
        pollJob(jobID);
      } catch (error) {
        setStatus(error.message || 'Generation failed.', true);
        byID('tc-progress').hidden = true;
        byID('tc-generate').disabled = false;
      }
    }, 4000);
  }

  async function generate() {
    if (!backend) {
      setStatus('Pick an animation model.', true);
      return;
    }
    var text = byID('tc-text').value.trim();
    if (!text) {
      setStatus('Write what the character should say.', true);
      return;
    }
    if (backend.input === 'video') {
      if (!byID('tc-video-url').value.trim()) {
        setStatus('Add a video URL to retalk, or pick a portrait model.', true);
        return;
      }
    } else if (!portrait) {
      setStatus('Choose, upload or generate a character portrait first.', true);
      return;
    }
    var button = byID('tc-generate');
    button.disabled = true;
    byID('tc-progress').hidden = false;
    byID('tc-result').classList.remove('tc-on');
    setStatus('Submitting…', false);

    var body = {
      backend: backend.id,
      text: text,
      response_mode: 'polling',
      portrait_edit: byID('tc-portrait-edit').value.trim(),
      prompt: '',
      seconds: estimateSeconds(),
    };
    if (backend.input === 'video') {
      body.video_url = byID('tc-video-url').value.trim();
    } else {
      body.image_url = portrait.image_url;
      body.portrait_slug = portrait.slug || '';
    }
    if (customVoiceURL) {
      body.ref_audio_url = customVoiceURL;
    } else if (voice) {
      body.voice_key = voiceKey(voice);
      body.voice_provider = voice.provider || '';
      body.voice_id = voice.provider_id || '';
      body.ref_audio_url = voice.url || '';
    }

    try {
      var response = await fetch('/api/talking-character', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(body),
      });
      var data = await response.json().catch(function () {
        return {};
      });
      if (!response.ok) {
        if (response.status === 401) {
          requireLogin();
          throw new Error('Sign in to generate talking characters.');
        }
        if (handlePaymentRequired(response, data)) throw new Error(data.error || 'Insufficient credits.');
        throw new Error(data.error || 'Generation failed.');
      }
      if (data.job_id) {
        setStatus('Queued · ' + (data.credits_charged || 0) + ' credits charged. Rendering…', false);
        pollJob(data.job_id);
        return;
      }
      var url = videoURLFrom(data.result) || videoURLFrom(data);
      if (!url) throw new Error('No video returned.');
      showResult(url);
      setStatus('Talking character ready.', false);
      byID('tc-progress').hidden = true;
      button.disabled = false;
    } catch (error) {
      setStatus(error.message || 'Generation failed.', true);
      byID('tc-progress').hidden = true;
      button.disabled = false;
    }
  }

  function bindTabs() {
    function showSource(source) {
      var create = source === 'create';
      byID('tc-source-choice').querySelectorAll('.tc-source-card').forEach(function (node) {
        node.classList.toggle('tc-on', node.dataset.source === source);
      });
      byID('tc-existing-controls').hidden = create;
      byID('tc-pane-generate').classList.toggle('tc-on', create);
      if (create) {
        byID('tc-pane-library').classList.remove('tc-on');
        loadSourcePortraits();
        return;
      }
      byID('tc-pane-library').classList.add('tc-on');
    }
    byID('tc-source-choice').addEventListener('click', function (event) {
      var source = event.target.closest('.tc-source-card');
      if (source) showSource(source.dataset.source || 'existing');
    });
  }

  function setupLaunchPortrait() {
    var params = new URLSearchParams(window.location.search);
    var state = params.get('avatar_state');
    if (avatarTestMode && state) {
      selectPortrait(testAvatarPortrait());
      setAvatarTestState(state);
      openNarrator();
      return;
    }
    if (params.get('mode') === 'create') {
      var createSource = document.querySelector('[data-source="create"]');
      if (createSource) createSource.click();
      if (params.get('prompt')) byID('tc-generate-prompt').value = params.get('prompt');
    }
    var imageURL = params.get('src') || params.get('image_url');
    if (!imageURL || !/^(https?:\/\/|\/static\/)/.test(imageURL)) return;
    var name = params.get('name') || 'Imported character';
    var prompt = params.get('prompt') || name;
    byID('tc-generate-prompt').value = prompt;
    selectPortrait({ slug: '', name: name, image_url: imageURL, prompt: prompt, source: 'import' });
    setAvatarBuildStatus('Character image imported. Review it, then create the transparent animated pack.', false);
    openNarrator();
  }

  function handleExternalAvatarAudio(event) {
    var detail = event.detail || {};
    var level = clamp(Number(detail.level || 0) * 5, 0, 1);
    if (detail.active === false || level <= 0.005) {
      avatarExternalLevel = 0;
      avatarExternalUntil = 0;
      if (avatarTalking && !avatarAudioReactive) stopAvatarTalk();
      return;
    }
    avatarExternalLevel = level;
    avatarExternalUntil = performance.now() + 180;
    if (!avatarTalking) startAvatarTalk(false);
  }

  function useAvatarInChat() {
    if (!portrait) return;
    var selected = {
      id: portrait.slug || portrait.id || 'talking-avatar',
      name: portrait.name || 'Character',
      image_url: portrait.image_url,
      assets: portrait.assets || {},
    };
    try {
      localStorage.setItem('netwrckChatCharacter', JSON.stringify(selected));
      localStorage.setItem('netwrckChatCharacterEnabled', 'true');
    } catch (error) {}
    window.dispatchEvent(new CustomEvent('netwrck:character-selected', { detail: selected }));
    byID('tc-narrator').close();
    setStatus('Character set for chat. Its PNG mouth states will follow chat audio.', false);
  }

  function init() {
    if (!byID('tc-gallery')) return;
    bindTabs();
    byID('tc-portrait-search').addEventListener('input', function () {
      window.clearTimeout(portraitTimer);
      portraitTimer = window.setTimeout(loadPortraits, 200);
    });
    byID('tc-source-search').addEventListener('input', function () {
      window.clearTimeout(sourcePortraitTimer);
      sourcePortraitTimer = window.setTimeout(loadSourcePortraits, 200);
    });
    byID('tc-voice-search').addEventListener('input', function () {
      window.clearTimeout(voiceTimer);
      voiceTimer = window.setTimeout(loadVoices, 200);
    });
    byID('tc-voice-chips').addEventListener('click', function (event) {
      var chip = event.target.closest('.tc-chip');
      if (!chip) return;
      voiceFilter = chip.dataset.filter || '';
      byID('tc-voice-chips')
        .querySelectorAll('.tc-chip')
        .forEach(function (node) {
          node.classList.toggle('tc-on', node === chip);
        });
      loadVoices();
    });
    byID('tc-portrait-file').addEventListener('change', function (event) {
      handlePortraitUpload(event.target.files[0]);
    });
    byID('tc-voice-file').addEventListener('change', function (event) {
      handleVoiceUpload(event.target.files[0]);
    });
    byID('tc-video-file').addEventListener('change', async function (event) {
      var file = event.target.files[0];
      if (!file) return;
      setStatus('Uploading clip…', false);
      try {
        byID('tc-video-url').value = await uploadFile(file, 'talking-clip', 'mp4');
        setStatus('Clip uploaded.', false);
      } catch (error) {
        setStatus('Clip upload failed.', true);
      }
    });
    byID('tc-record').addEventListener('click', toggleRecording);
    byID('tc-generate-portrait').addEventListener('click', function () { generatePortrait(false); });
    byID('tc-generate-full').addEventListener('click', function () { generatePortrait(true); });
	byID('tc-generate-framing').addEventListener('change', refreshAvatarCreationPricing);
    byID('tc-build-avatar').addEventListener('click', buildAvatarAssets);
    byID('tc-narrator-build').addEventListener('click', buildAvatarAssets);
    ensureVideoAvatarButton();
    byID('tc-generate').addEventListener('click', generate);
    byID('tc-text').addEventListener('input', refreshEstimate);
    byID('tc-portrait-edit').addEventListener('input', refreshEstimate);
    byID('tc-avatar-stage').addEventListener('click', openNarrator);
    byID('tc-open-narrator').addEventListener('click', openNarrator);
    byID('tc-narrator-close').addEventListener('click', function () { byID('tc-narrator').close(); });
    byID('tc-narrator-use').addEventListener('click', useAvatarInChat);
    byID('tc-narrator-demo').addEventListener('click', function () {
      if (avatarTalking) stopAvatarTalk();
      else startAvatarTalk();
    });
    byID('tc-performance-start').addEventListener('click', startAvatarPerformance);
    byID('tc-performance-calibrate').addEventListener('click', resetWebcamCalibration);
    byID('tc-performance-record').addEventListener('click', togglePerformanceRecording);
    byID('tc-performance-stop').addEventListener('click', stopAvatarPerformance);
    byID('tc-narrator').addEventListener('close', function () {
      if (avatarWebcamRunning) stopAvatarPerformance();
      else stopAvatarTalk();
    });
    byID('tc-voice-preview').addEventListener('play', function () { startAvatarTalk(true); });
    byID('tc-voice-preview').addEventListener('ended', stopAvatarTalk);
    byID('tc-voice-preview').addEventListener('pause', stopAvatarTalk);
    window.addEventListener('netwrck:character-audio', handleExternalAvatarAudio);

    if (avatarTestMode) {
      window.__talkingAvatarTest = {
        selectPortrait: selectPortrait,
        setState: setAvatarTestState,
        setPose: setAvatarTestPose,
        start: function () { startAvatarTalk(false); },
        stop: stopAvatarTalk,
        snapshot: avatarSnapshot,
        fixture: testAvatarPortrait,
		reset: resetAvatarTest,
		assetKeys: avatarAssetKeys.slice(),
		isReady: hasAnimatedAvatar,
      };
    }

    setupLaunchPortrait();
    loadPortraits();
    loadVoices();
    loadBackends();
    loadStyleOptions();
    refreshEstimate();
    refreshPerformanceUI();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
